export const about = {
  pageTitle: 'Over',
  pageSubtitle: 'Meer dan 15 jaar ervaring in dienst van uw renovatie- en bouwprojecten in Brussel. Een Belgisch bedrijf dat kwaliteit en klanttevredenheid centraal stelt',
  
  // Story Section
  storyTitle: 'Ons Verhaal',
  storyP1: 'Opgericht door <strong>Al Mohammad Abdul</strong>, is Ktran ontstaan uit een passie voor de bouw en een toewijding aan uitmuntendheid. Met meer dan 15 jaar ervaring in de renovatiesector hebben we een erkende expertise ontwikkeld in Brussel en omgeving',
  storyP2: 'Onze aanpak is gebaseerd op drie fundamentele pijlers: aandachtig luisteren naar onze klanten, superieure kwaliteit van onze realisaties, en strikte naleving van afgesproken deadlines en budgetten',
  storyP3: 'Elk project is uniek en verdient bijzondere aandacht. Daarom nemen we de tijd om uw behoeften te analyseren, u te adviseren over de beste oplossingen, en u van A tot Z te begeleiden in uw renovatieproject',
  storyP4: 'Gevestigd in Molenbeek-Sint-Jans, is ons Belgisch bedrijf trots om bij te dragen aan de verbetering van het Brusselse vastgoedpatrimonium, één project tegelijk',
  storyYears: 'Jaar ervaring',
  
  // Values Section
  valuesTitle: 'Onze Waarden',
  valuesSubtitle: 'Principes die elk van onze interventies sturen en uw tevredenheid garanderen',
  
  qualityTitle: 'Kwaliteit van het Werk',
  qualityDesc: 'We gebruiken materialen van superieure kwaliteit en passen de beste technieken toe om duurzame en esthetische resultaten te garanderen',
  
  timeTitle: 'Respect voor Deadlines',
  timeDesc: 'Elk project wordt nauwkeurig gepland. We verbinden ons ertoe de afgesproken deadlines te respecteren voor uw gemoedsrust',
  
  cleanTitle: 'Propere Werf',
  cleanDesc: 'We houden de werf georganiseerd en proper gedurende de hele duur van de werken, met een volledige schoonmaak aan het einde van elke dag',
  
  communicationTitle: 'Transparante Communicatie',
  communicationDesc: 'We houden u op de hoogte in elke fase van het project. We blijven beschikbaar om uw vragen te beantwoorden en aan te passen volgens uw behoeften',
  
  // Timeline
  timelineTitle: 'Ons Parcours',
  timelineSubtitle: 'Een continue groei gebaseerd op vertrouwen en kwaliteit',
  
  timeline2008Title: 'Begin van het Avontuur',
  timeline2008Desc: 'Al Mohammad Abdul start zijn bouw- en renovatieactiviteit in Brussel',
  
  timeline2015Title: 'Uitbreiding van Diensten',
  timeline2015Desc: 'Uitbreiding van het team en diversificatie van diensten om aan alle renovatiebehoeften te voldoen',
  
  timeline2020Title: 'Kwaliteitscertificering',
  timeline2020Desc: 'Verkrijging van professionele certificeringen en versterking van onze toewijding aan uitmuntendheid',
  
  timeline2024Title: 'Meer dan 150 Projecten',
  timeline2024Desc: 'Vandaag wordt Ktran erkend als een betrouwbare speler in renovatie in Brussel en omgeving',
  
  // Service Area
  serviceAreaTitle: 'Interventiegebied',
  serviceAreaText: 'We werken voornamelijk in <strong>Brussel en omgeving</strong>, met een grondige kennis van lokale specificiteiten en geldende Belgische normen',
  
  areaBrusselsTitle: 'Brussels Hoofdstedelijk Gewest',
  areaBrusselsDesc: 'Alle gemeenten van Brussel',
  
  areaPeripheryTitle: 'Brusselse Rand',
  areaPeripheryDesc: 'Waals en Vlaams Brabant',
  
  areaOnDemandTitle: 'Verplaatsingen op Aanvraag',
  areaOnDemandDesc: 'Contacteer ons voor andere regio\'s',
  
  // Contact Info
  contactInfoTitle: 'Contactgegevens',
  contactCompany: 'Ktran',
  contactVAT: 'BTW-nr: BE0729535515',
  contactAddress1: 'Rotterdamstraat 50',
  contactAddress2: '1080 Molenbeek-Sint-Jans',
  contactAddress3: 'België',
  
  // CTA
  ctaTitle: 'Laten We Samenwerken aan Uw Project',
  ctaText: 'Contacteer ons om uw renovatieproject te bespreken. We ontmoeten u graag en stellen u een oplossing voor die is aangepast aan uw behoeften',
  ctaQuote: 'Vraag een Offerte Aan',
  ctaCall: 'Bel Ons'
};